import { CoreGlobalFooter } from '@care/navigation';
import { type SegmentationListingPageProps } from '@/components/feature/searchDirectory/SearchDirectoryProps';
import { IterableBannerSection } from '@/components/common/IterableBannerSection';
import { SearchDirectoryDataProvider } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { FAQSection } from '@/components/feature/searchDirectory/FAQSection';
import { SeoConversionBox } from '@/components/common/SeoConversionBox';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';
import { InternalLinkingSection } from '@/components/feature/searchDirectory/InternalLinkingSection';
import { BreadcrumbsSection } from '@/components/feature/searchDirectory/BreadcrumbsSection';
import { HeroSection } from './components/section/HeroSection';
import { SearchResultsWithAsideSection } from './components/section/SearchResultsWithAsideSection';
import { ValuePropSection } from './components/section/ValuePropSection';

export const JobSearchDirectory = ({ pageData }: SegmentationListingPageProps) => {
  const { enrollmentURL } = usePageAttributes();

  return (
    <SearchDirectoryDataProvider pageData={pageData}>
      <IterableBannerSection />
      <HeroSection />
      <ValuePropSection />
      <SearchResultsWithAsideSection />
      <SeoConversionBox enrollmentURL={enrollmentURL ?? ''} />
      <FAQSection />
      <InternalLinkingSection />
      <BreadcrumbsSection />
      <CoreGlobalFooter variant="inverse" />
    </SearchDirectoryDataProvider>
  );
};

export default JobSearchDirectory;
